import { Injectable } from '@angular/core';

declare let gtag: any;

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  constructor() { }

  /**
   * Initialise Google Tag Manager
   */
  init(): void {
    // Initialisation du dataLayer si pas déjà fait
    if (typeof window !== 'undefined') {
      (window as any).dataLayer = (window as any).dataLayer || [];
    }
  }

  /**
   * Envoie un événement de changement de page à GTM
   * @param pagePath - Le chemin de la page
   * @param pageTitle - Le titre de la page
   */
  trackPageView(pagePath: string, pageTitle: string): void {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'page_view',
        page_path: pagePath,
        page_title: pageTitle,
        page_location: window.location.href
      });
    }
  }

  /**
   * Envoie un événement personnalisé à GTM
   * @param eventName - Nom de l'événement
   * @param parameters - Paramètres de l'événement
   */
  trackEvent(eventName: string, parameters: any = {}): void {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: eventName,
        ...parameters
      });
    }
  }

  /**
   * Envoie un événement de conversion
   * @param conversionName - Nom de la conversion
   * @param value - Valeur de la conversion
   */
  trackConversion(conversionName: string, value?: number): void {
    this.trackEvent('conversion', {
      conversion_name: conversionName,
      conversion_value: value
    });
  }
}
